import i18n from "../../i18n/i18next";
import { defaultAddSnack } from "../../state/overlayState/overlayContext";
import { isDebugUser, Utils } from "../../utils";

export const logInterResponseError = async (error: any) => {
  Utils.pushLog({
    tags: ["HTTP", "ERROR"],
    message: error.message,
    extraArgs: [error],
    timeStamp: Date.now(),
  });
  // TODO: Handle more error codes
  if (error.code === "ECONNABORTED") {
    // Requests usually time out in batches, and on iOS concurrent native toasts race past
    // `hideAll()`, so without the id one outage stacks several. The id resets on app resume.
    if (isDebugUser()) defaultAddSnack(i18n.t("snack.networkError"), "error", false, "network-error");
  }

  return Promise.reject(error);
};
